document.addEventListener("DOMContentLoaded", function () {
    // Select all rows with the class `product-tab-cstm`
    const collapsibleRows = document.querySelectorAll(".product-tab-cstm");

    collapsibleRows.forEach((row) => {
        // Check if the `.collapsible-row--content-wrapper` exists within the row
        const contentWrapper = row.querySelector(".collapsible-row--content-wrapper");

        if (!contentWrapper) {
            // Add the `display: none !important;` CSS to the `.product-tab-cstm`
            row.classList.add("hide-collapsible-row");
        }
    });

    // Check if any `.product-tab-cstm` is present on the page
    if (document.querySelector(".product-tab-cstm")) {
        // Add the `display: none !important;` CSS to `.product-e-cstm`
        const productEElements = document.querySelectorAll(".product-e-cstm");
        productEElements.forEach((element) => {
            element.classList.add("hide-product-e");
        });
    }
});

// Add the CSS dynamically to hide the rows and `.product-e-cstm`
const style = document.createElement("style");
style.innerHTML = `
    .product-tab-cstm.hide-collapsible-row {
        display: none !important;
    }
    .product-e-cstm.hide-product-e {
        display: none !important;
    }
`;
document.head.appendChild(style);
